import { config } from "./config";
import { useOrg } from "../auth/org-provider";

export function useIsDemoOrg(): boolean {
    const org = useOrg();
    return !!config.demoOrgId && org.id === config.demoOrgId;
}
